import { keyframes } from '@emotion/react'
export const makeFloatAnimation = distance => keyframes`
0% { transform: translate(0,  0px); }
50%  { transform: translate(0, -${distance}px); }
100%   { transform: translate(0, -0px); }`
